<template>
<div>
<ContentHeader :title="$store.state.languages.lang_phrases.audit"  :show_button="false" ></ContentHeader>



<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>




<template v-if="!loading">
<div class="mt-4">

<div class="grid">
<template v-if="$store.state.flows.flow.questionlist">
  <div class="col-11">
  <ClickEditSelect title="Soru Listesi" :value="flowquestionlist" :options="questionlists" valkey="questionlist" @dataChanged="dataChanged"  :filter="true"/>
  </div>
  <div class="col-1">
<Button type="button"  icon="pi pi-external-link"  class="p-button-primary p-button-outlined p-button-sm mt-3"  @click="gotoQuList" />
  </div>

</template>

<template v-else>
  <div class="col-12">
    <ClickEditSelect title="Soru Listesi" :value="flowquestionlist" :options="questionlists" valkey="questionlist" @dataChanged="dataChanged"  :filter="true"/>
  </div>
</template>
</div>



<ClickEditNumber  title="Denetleme Süresi (saat)" :value="item.auditsettings.duration" valkey="duration" @dataChanged="settingsChanged"   />


<ClickEditSwitch  :title="$store.state.languages.lang_phrases.teknik_denetleme_gerekli" :value="item.auditsettings.requires_tech_audit" valkey="requires_tech_audit" @dataChanged="settingsChanged" />

<ClickEditSwitch  :title="$store.state.languages.lang_phrases.online" :value="item.auditsettings.is_online" valkey="is_online" @dataChanged="settingsChanged" />

<ClickEditSwitch  :title="$store.state.languages.lang_phrases.donem_bittiginde_uygunsuzluk_kapatabilme" :value="item.auditsettings.allow_closure_after_expire" valkey="allow_closure_after_expire" @dataChanged="settingsChanged" />

<ClickEditSwitch  :title="$store.state.languages.lang_phrases.donem_sonu_bitmemis_isleri_yeni_doneme_tasi" :value="item.auditsettings.carry_uncompleted_work_to_new_season" valkey="carry_uncompleted_work_to_new_season" @dataChanged="settingsChanged" />



<ClickEditMultiSelect :title="$store.state.languages.lang_phrases.muafiyet_sertifikalari" :value="item.exemption_certificates" :options="certificate_types" valkey="exemptioncertificates" @dataChanged="settingsChanged" :showaschips="false" />





<div class="grid grid-nogutter">

<div class="col-8"><h4 class="text-primary">{{$store.state.languages.lang_phrases.iliskili_ozel_nitelikler}}</h4></div>

<div class="col-4 flex align-items-center justify-content-end"><Button v-if="!addingnew" type="button" :class="'p-button-primary p-button-outlined p-button-sm mt-2'" :label="$store.state.languages.lang_phrases.yeni_ekle" icon="pi pi-plus" @click="addNew" /></div>

<div class="col-10 my-2" v-if="addingnew">
<Dropdown v-model="selected_attribute" :options="custom_attributes" filter  optionLabel="name" optionValue="id" placeholder="Özel Nitelik Seçin" class="w-full p-inputtext-sm" @change="attributeSelected"/>
</div>
<div class="col-2 my-2 flex align-items-center justify-content-end" v-if="addingnew">
<Button type="button" :class="'p-button-danger p-button-outlined p-button-sm '" :label="$store.state.languages.lang_phrases.iptal" icon="pi pi-times" @click="cancelAddNew" />
</div>

<div class="col-12"><hr></div>
<div class="col-1"></div>
<div class="col-9"><p class="font-bold">{{$store.state.languages.lang_phrases.isim}}</p></div>
<div class="col-1"><p class="font-bold">{{$store.state.languages.lang_phrases.gerekli}}</p></div>
<div class="col-1"></div>

</div>


<draggable 
v-model="item.flowattributes"
@change="reorderCustomAttributes"
v-bind="dragOptions"
handle=".handle"
item-key="id"> 
<template #item="{element}">
<div class="grid">
<div class="col-1 handle">
 <span class="material-symbols-outlined">
drag_handle
</span> 
</div>
<div class="col-9"><p class="text-primary my-0">{{element.customattribute.name}}</p></div>
<div class="col-1"><InputSwitch v-model="element.is_required" @change="updateRequired(element.id)" /></div>
<div class="col-1"><Button type="button" icon="pi pi-trash" class=" p-button-danger p-button-outlined  p-button-sm" @click="deleteAttribute(element.id)"></Button></div>

</div>
</template>
</draggable>



<!--
<ClickEditMultiSelect :title="$store.state.languages.lang_phrases.iliskili_ozel_nitelikler" :value="item.customattributes" :options="custom_attributes" valkey="customattributes" @dataChanged="settingsChanged"  />
-->


<Button label="Denetleme Yükle" icon="pi pi-check" @click="showUploader"   class="p-button-primary p-button-outlined p-button-sm mt-4" />

<Button label="Uygunsuzluklar" icon="pi pi-check" @click="goToNonconformities"   class="p-button-primary p-button-outlined p-button-sm mt-4" />



</div>
<!--
<ClickEditSwitch  title="Tedarikçiler Gün Seçebilsin" :value="verificationsettings.allow_self_schedule" valkey="allow_self_schedule" @dataChanged="settingsChanged" />
<ClickEditNumber  title="Max Seçilebilir Gün Sayısı" :value="verificationsettings.selectable_days_count" valkey="selectable_days_count" @dataChanged="settingsChanged" v-show="verificationsettings.allow_self_schedule"  />

<ClickEditNumber  title="Doğrulama Oturum Süresi(saat)" :value="verificationsettings.session_duration" valkey="session_duration" @dataChanged="settingsChanged"   />

-->


</template>
<FlowQuestionlistCloneModal @questionlistselected="questionlistselected"></FlowQuestionlistCloneModal>
<AuditUploadDialog ref="audituploaddialog"></AuditUploadDialog>
</div>



</template>

<script>
import * as XLSX from 'xlsx/xlsx.mjs';
import moment from "moment"
import FlowQuestionlistCloneModal from "./FlowQuestionlistCloneModal"
import AuditUploadDialog from "../../components/pagecomponents/AuditUploadDialog"
export default {

  name: 'FlowAudit',

  data () {
    return {
      loading:true,
      addingnew:false,
      selected_attribute:null,
      flowquestionlist:null,
      item:{questionlist_id:null,duration:null},
      questionlists:[],
      selectedquestionlist:{name:"Soru Listesi Seç",id:0},
      custom_attributes:[],
      certificate_types:[],
    }
  },
  components:{FlowQuestionlistCloneModal,AuditUploadDialog},
  mounted()
  {
    //this.$store.dispatch('ui/setActiveTab',"verification") 
    
    this.getData()
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        disabled: false,
        ghostClass: "ghost"
      };
    }
  },  
  methods:{
    attributeSelected()
    {
      console.log(this.selected_attribute)
      let check = this.item.flowattributes.findIndex(item=>item.customattribute.id == this.selected_attribute)
      if(check ==-1)
      {
        let formdata = new FormData()
        formdata.append("attribute_id",this.selected_attribute) 
        this.silentSubmission(formdata,"flow_attribute/store/"+this.item.id,this.afterAttributesAdded)
      }
      else
      {
        this.selected_attribute = null
        this.addingnew = false
      } 
    },
    afterAttributesAdded(response)
    {
      this.selected_attribute = null
      this.addingnew = false
      this.item.flowattributes = response.data
      for(let element of this.item.flowattributes)
      {
        if(element.is_required===1)
        {
          element.is_required = true
        }
        else
        {
          element.is_required = false
        }
      }
    },
    addNew()
    {
      this.addingnew = true
    },
    cancelAddNew()
    {
      this.selected_attribute = null
      this.addingnew = false
    },
    afterAttributesAltered(response)
    {
      console.log(response)
    },
    updateRequired(id)
    {
      let item = this.item.flowattributes.find(element =>element.id == id)

      console.log(this.item.flowattributes)
      let formdata = new FormData()
      formdata.append("is_required",item.is_required) 
      this.silentSubmission(formdata,"flow_attribute/update/"+id,this.afterAttributesAltered)
    },
    deleteAttribute(id)
    {
      let formdata = new FormData()
      this.silentSubmission(formdata,"flow_attribute/delete/"+id,this.afterAttributesAltered)
      this.item.flowattributes = this.item.flowattributes.filter(item=>item.id !==id)
    },
    reorderCustomAttributes()
    {
      let items = this.item.flowattributes.map(item=>item.id)
      console.log(items)
      let formdata = new FormData()
      formdata.append("customattributes",JSON.stringify(items)) 
      this.silentSubmission(formdata,"flow_attribute/reorder",this.afterAttributesAltered)
    },
    goToNonconformities()
    {
      this.$router.push({ name: 'FlowNonconformities' })
    },
    showUploader()
    {
      this.$refs.audituploaddialog.open()
    },
    questionlistselected(fields)
    {
      let formdata = this.createFormData(JSON.parse(JSON.stringify(fields)))
      formdata.append("flow_id",this.$route.params.id) 
      formdata.append("questionlist_id",this.$store.state.flows.qu_list_to_clone.id)  
      this.generalSubmission(formdata,"questionlists/clone_list",this.afterquestionlistselected)
    },
    afterquestionlistselected(response)
    {
      this.$store.dispatch('flows/setShowCloneModal',false) 
      console.log(response.data) 
      this.gotoPage('Questionlist',{id:response.data.id})
    },  
    async resolveCustomAttributes(item)
    {
      /*
       item.customattributes = await []
        for(let element of item.flowattributes)
        {
          let customattribute = await element.customattribute
          await item.customattributes.push(customattribute)
        }
        */

        /*
       item.required_certificates = await []
       for(let element of item.requiredcertificates)
        {
          let certificatetype = await element.certificatetype
          await item.required_certificates.push(certificatetype)
        }
        */
      for(let element of item.flowattributes)
      {
        if(element.is_required===1)
        {
          element.is_required = true
        }
        else
        {
          element.is_required = false
        }
      }
      item.exemption_certificates = await []
      for(let element of item.exemptioncertificates)
      {
          let certificatetype = await element.certificatetype
          await item.exemption_certificates.push(certificatetype)
      }

        return await item
    },
    async getData()
    {
        let custom_attributes = await this.generalApiGetWithoutLoader("custom_attributes/brand_attributes/"+this.$store.state.flows.flow.brand_id)

        for(let attribute of custom_attributes)
        {
          if(attribute.group)
          {
            attribute.name = attribute.name+" ("+attribute.group.name+")"
          }
        }
        this.custom_attributes = custom_attributes
        
        this.certificate_types = await this.generalApiGetWithoutLoader("certificatetypes")

         
        let questionlists = await this.generalApiGetWithoutLoader("questionlists")
        for(let questionlist of questionlists)
        {
          

          if(questionlist.brand_id == this.$store.state.flows.flow.brand_id)
          {
            questionlist.name = questionlist.name+" - "+ questionlist.brand.name
            
          }
          else
          {
            questionlist.name = questionlist.name+" - "+questionlist.brand.name+" - kopyasını oluştur"
          }
        }
        
        this.questionlists = await questionlists
        await this.questionlists.push({name:"Soru Listesi Oluştur",id:0})
        
        if(this.$store.state.flows.flow.questionlist)
        {
          this.flowquestionlist = await this.$store.state.flows.flow.questionlist
        }
        let item = await this.generalApiGetWithoutLoader("flow/get_flow_audit_data/"+this.$route.params.id)
        item = await this.resolveCustomAttributes(item)
          console.log(item)
          this.item = await item
        console.log(this.item)
        
        

        
        this.loading = await false
    },
    dataChanged(data)
    {
      console.log(data)      
      if(data.value==0)
      {
        this.gotoPage('FlowNewQuestionlist')
      }
      else
      {

        let item = this.questionlists.find((item)=>{return item.id == data.value})
        console.log(item)
        console.log(this.$store.state.flows.flow.brand_id)
        if(item.brand_id !== this.$store.state.flows.flow.brand_id)
        {
          this.$store.dispatch('flows/setQuListToClone',item) 
          this.$store.dispatch('flows/setShowCloneModal',true) 
          return false
        }

        let formdata = new FormData()
        formdata.append("flow_id",this.$route.params.id) 
        formdata.append("questionlist_id",data.value) 
        this.generalSubmission(formdata,"questionlists/select_flow",this.afterSubmit)
      }
    },
    async afterSubmit(response)
    {
        console.log(response.data) 
        let item = await this.generalApiGetWithoutLoader("flow/"+this.$route.params.id) 
        this.$store.dispatch('flows/setFlow',item)
        this.flowquestionlist =  item.questionlist
      
    },
    gotoQuList()
    {
      console.log(this.$store.state.flows.flow.questionlist.id)
      this.gotoPage('Questionlist',{id:this.$store.state.flows.flow.questionlist.id})
    },
    settingsChanged(data)
    {
      console.log(data)
      let formdata = new FormData()
      if(data.key=="customattributes" || data.key=="requiredcertificates" || data.key=="exemptioncertificates")
      {
        formdata.append(data.key,JSON.stringify(data.value)) 
      }
      else
      {
        formdata.append(data.key,data.value) 
      }
      
      this.generalSubmission(formdata,"flow/audit_settings/"+this.item.auditsettings.id,this.aftersettingsChanged)
    },
    async aftersettingsChanged(response)
    {
      console.log(response.data)
      let item = response.data
      item =  await  this.resolveCustomAttributes(item)
      console.log(item)
      this.item =  item
    },
  }
};
</script>

<style lang="css" scoped>
</style>